import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import chaticon from '../../utils/images/chat-icon.svg';
import keyboardicon from "../../utils/images/keyboard-icon.svg";
import MagneticElement from "../IvyChatboot/MagneticElement";
import chatbooticon from "../../utils/images/banner_img.png";
import ViewIcon from "../../utils/images/view_icon.svg";
import image from "../../utils/images/image.png";
import fullscreenview from "../../utils/images/full-screen-view.png";
// import { useGSAP } from "@gsap/react";
import Modal from "react-bootstrap/Modal";
import logo from "../../utils/images/logo.svg";
import closeicon from "../../utils/images/close-icons.svg";
import playicon from "../../utils/images/play-icon.svg";
import bannerimg from "../../utils/images/banner_img.png";
// import pauseicon from "../../utils/images/pause-icon.svg";
// import gsap from "gsap";




function IvyChatboot() {
    const [isImageVisible, setIsImageVisible] = useState(false);
    const navigate = useNavigate()
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);
    const [isFullscreen, setIsFullScreen] = useState(false);

    const handleClick = () => {
        setIsImageVisible(!isImageVisible);
        
    };

    useEffect(() => {

        if (!isFullscreen) {
            // setIsChat(true)
        }
    }, [isFullscreen, show])

    // useGSAP(() => {
    //     const tl3 = gsap.timeline().from("#group-svg path", {
    //         delay: 0.5,
    //         y: 25,
    //         // opacity: 0,
    //         stagger: {
    //             amount: 0.4,
    //         },
    //         skewY: 20,
    //         onComplete: () =>
    //             gsap
    //                 .timeline({
    //                     repeat: -1,
    //                     repeatDelay: 1,
    //                 })
    //                 .to(".FullScreenView .penny-tittle svg", {
    //                     scale: 0.95,
    //                 })
    //                 .to(".FullScreenView .penny-tittle svg", { scale: 1 }),

    //         // repeat: -1,
    //     });
    //     const tl = gsap.timeline({
    //         repeat: -1,
    //         yoyo: true,
    //         paused: true,
    //     });
    //     // const tl3 = gsap.timeline().from("#group-svg path", {
    //     //   delay: 0.5,
    //     //   y: 25,
    //     //   stagger: {
    //     //     amount: 0.4,
    //     //   },
    //     //   skewY: 20,
    //     //   onComplete: () =>
    //     //     gsap
    //     //       .timeline({
    //     //         repeat: -1,
    //     //       })
    //     //       .to(".FullScreenView .penny-tittle svg", {
    //     //         scale: 0.95,
    //     //         duration: 0.6,
    //     //         ease: "power1.inOut",
    //     //       })
    //     //       .to(".FullScreenView .penny-tittle svg", {
    //     //         scale: 1,
    //     //         duration: 0.6,
    //     //         ease: "power1.inOut",
    //     //       }),
    //     // });
    //     tl.to(
    //         ".circle2.thinking",
    //         {
    //             scale: 0.95,
    //         },
    //         "start1"
    //     )
    //         .to(
    //             ".circle2.thinking",
    //             {
    //                 duration: 0.5,
    //                 scale: 1,
    //             },
    //             "start2"
    //         )
    //         .to(
    //             ".circle2 .box12, .circle2 .box22",
    //             {
    //                 scale: 0.95,
    //                 stagger: {
    //                     amount: 0.4,
    //                 },
    //             },
    //             "start1"
    //         )
    //         .to(
    //             ".circle2 .box12, .circle2 .box22",
    //             {
    //                 scale: 1,
    //                 stagger: {
    //                     amount: 0.4,
    //                 },
    //             },
    //             "start2"
    //         )
    //     const tl2 = gsap.timeline({
    //         repeat: -1,
    //         yoyo: true,
    //         paused: true,
    //     });
    //     tl2
    //         .to(".circle3 .box", {
    //             ease: "none",
    //             scale: 0.9,
    //             duration: 0.15,
    //             stagger: {
    //                 amount: 0.5,
    //             },
    //         })
    //         .to(
    //             ".circle3 .box",
    //             {
    //                 ease: "none",
    //                 scale: 1,
    //                 duration: 0.15,
    //                 stagger: {
    //                     amount: 0.5,
    //                 },
    //             },
    //             "-=30%"
    //         );

    //     if (playng) {
    //         tl2.play();
    //     }
    //     if (processing) {
    //         tl.play();
    //     }
    // }, [playng, processing]);
  
    return (
        <>
            <div className="full_screen">
                <div className="container">
                    <div className="chatboot">
                        <MagneticElement>
                            <div className="circle-1" onClick={handleClick}>
                                <img src={chatbooticon} alt='' />
                            </div>
                        </MagneticElement>
                        {isImageVisible && (<div className='actions-button'>
                            <button
                                onClick={handleShow}
                                className="first-button"
                            >
                                <img src={chaticon} alt='' />
                            </button>
                            <button
                                onClick={() => navigate("/chat")}
                                className="second-button"
                            >
                                <img src={keyboardicon} alt='' />
                            </button>
                        </div>)}
                    </div>
                </div>
            </div>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                className={`${isFullscreen ? "FullScreenView" : "smallScreenView"
                    } landing-modal`}
            >
                <Modal.Body>
                    <div className="full_screen">
                        <div
                            className={`${isFullscreen ? "FullScreenView" : "smallScreenView"
                                } chat-bot`}
                        >
                            <div className="penny-tittle">
                                <img src={logo} alt="" />
                            </div>
                            <div className="viewfullscreen"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "20px 0",
                                }}
                            >
                                <p className="gradient-box d-none d-md-block">
                                    {/* {listening ? "" : ""} */}
                                    <img
                                        src={!isFullscreen ? ViewIcon : fullscreenview}
                                        alt=""
                                        className={`${isFullscreen ? "FullScreenView" : "smallScreenView"
                                            }`}
                                        onClick={() => setIsFullScreen(!isFullscreen)}
                                    />
                                    {/* <div className="box-showd"></div> */}
                                </p>
                                {/* <p className="transcript-text">{transcript}</p> */}
                                <img src={image} alt="" className="bg_img" />
                            </div>
                            <div className="content-tittle">
                                <h2>Hello, James.</h2>
                                {/* <p>Welcome back. Rocky bhai</p> */}
                                <p>Welcome back.</p>
                                <span>How can I help you today?</span>
                            </div>

                            <div
                                className="bottom-icon"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "26px",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    position: "relative",
                                }}
                            >
                                <div
                                    onClick={() => {
                                    }}
                                >
                                    {/* <div className={`${playng ? "box02 box" : ""}`}></div>
                                    <div className={`${playng ? "box12 box" : ""}`}></div>
                                    <div className={`${playng ? "box22 box" : ""}`}></div>
                                    <div className={`${playng ? "box32 box" : ""}`}></div>
                                    <div className={`${playng ? "box42 box" : ""}`}></div>
                                    <div className={`${playng ? "box52 box" : ""}`}></div> */}
                                    {/* <div
                                        className={`${processing && !playng ? "box12" : ""}`}
                                    ></div>
                                    <div
                                        className={`${processing && !playng ? "box22" : ""}`}
                                    ></div> */}
                                </div>
                                <div className="circle2"
                                >
                                    <div className="box">
                                        <img src={bannerimg} alt="" />
                                    </div>
                                    {/* <div className="box"></div>
                                    <div className="box"></div>
                                    <div className="box"></div>
                                    <div className="box"></div>
                                    <div className="box"></div> */}
                                </div>

                                <div
                                    className="bottom-icons">
                                    <button
                                        style={{
                                            backgroundColor: "transparent",
                                            cursor: "pointer",
                                            border: "0",
                                        }}
                                    >
                                        <img src={playicon} alt="" />
                                    </button>
                                    <button
                                        style={{
                                            backgroundColor: "transparent",
                                            cursor: "pointer",
                                            border: "0",
                                        }}
                                        onClick={() => setShow(false)}
                                    >
                                        <img src={closeicon} alt="" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>

    );
}

export default IvyChatboot;